var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 48,
    viewBox: "0 0 159 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3008 21.0837V31.195H75.9039V23.7561L78.94 31.195H80.3413L83.3752 23.7561V31.195H84.9806V21.0837H82.8696L79.6951 29.0417L76.464 21.0837H74.3008Z",
    fill: "url(#paint0_linear_9396_16172)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1888 29.8373H93.8849C93.5539 29.8373 93.3951 29.6627 93.3951 29.316V26.3989C93.3951 25.533 93.1185 24.8666 92.5857 24.4043C92.0528 23.9419 91.2705 23.7129 90.2864 23.7129C89.4844 23.6789 88.6916 23.896 88.019 24.334C87.7356 24.5273 87.4998 24.7824 87.3293 25.08C87.1589 25.3775 87.0582 25.7099 87.0349 26.0521H88.5677C88.5968 25.8937 88.6579 25.7429 88.7472 25.6089C88.8364 25.4748 88.952 25.3604 89.0869 25.2724C89.4241 25.0559 89.8204 24.9497 90.2207 24.9686C90.6499 24.9483 91.0732 25.0755 91.4202 25.329C91.5632 25.4452 91.6771 25.5932 91.7527 25.7613C91.8283 25.9294 91.8635 26.1128 91.8555 26.2969V26.7502H89.9894C88.9509 26.7502 88.1754 26.9768 87.6335 27.3712C87.3655 27.5736 87.1515 27.839 87.0107 28.1438C86.8699 28.4487 86.8066 28.7836 86.8263 29.1188C86.8112 29.4245 86.8717 29.7293 87.0027 30.0061C87.1336 30.2828 87.3308 30.523 87.5768 30.7054C88.0688 31.0952 88.7332 31.2834 89.5699 31.2834C90.0534 31.306 90.5342 31.2002 90.9635 30.9769C91.3928 30.7535 91.7554 30.4206 92.0142 30.0118C92.0012 30.1729 92.0228 30.3349 92.0775 30.487C92.1323 30.6391 92.219 30.7777 92.3317 30.8935C92.5335 31.0952 92.8804 31.1972 93.3725 31.1972H94.1956L94.1888 29.8373ZM91.8487 27.9016V28.1623C91.8526 28.4192 91.8046 28.6743 91.7076 28.9122C91.6106 29.1502 91.4666 29.3661 91.2841 29.5471C90.8716 29.9126 90.3311 30.1001 89.7808 30.0685C89.4199 30.0948 89.0614 29.992 88.7695 29.7783C88.6519 29.6898 88.5576 29.574 88.4948 29.441C88.432 29.3079 88.4025 29.1615 88.409 29.0145C88.3997 28.8553 88.4305 28.6964 88.4986 28.5522C88.5668 28.4081 88.67 28.2833 88.799 28.1895C89.1296 27.9785 89.5185 27.8777 89.91 27.9016H91.8487Z",
    fill: "url(#paint1_linear_9396_16172)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5625 23.799H99.2156C98.7428 23.7731 98.272 23.8782 97.8551 24.1027C97.5135 24.2951 97.2288 24.5743 97.0298 24.9119L96.8574 23.799H95.4697V31.1949H97.0298V27.4822C97.0089 26.9213 97.1608 26.3674 97.4651 25.8956C97.7531 25.4763 98.2156 25.261 98.8664 25.261H99.5603L99.5625 23.799Z",
    fill: "url(#paint2_linear_9396_16172)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.986 21.0837V31.195H102.54V29.3024L103.855 27.9152L106.052 31.195H107.902L104.968 26.7751L107.73 23.7991H105.916L102.54 27.4053V21.0837H100.986Z",
    fill: "url(#paint3_linear_9396_16172)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.889 25.5171C108.576 26.1347 108.421 26.8197 108.435 27.5117C108.413 28.1994 108.569 28.8812 108.889 29.4904C109.192 30.0539 109.654 30.5159 110.217 30.8187C110.843 31.1405 111.54 31.2965 112.242 31.272C113.042 31.3035 113.827 31.047 114.453 30.5489C115.032 30.0875 115.422 29.4306 115.551 28.7017H113.991C113.898 29.0889 113.674 29.432 113.356 29.6718C112.996 29.9054 112.572 30.0211 112.143 30.0027C111.873 30.0153 111.605 29.9718 111.353 29.875C111.102 29.7783 110.873 29.6303 110.682 29.4406C110.29 29.0271 110.072 28.4783 110.075 27.9084V27.8222H115.653C115.682 27.6264 115.698 27.4287 115.698 27.2306C115.7 26.5773 115.53 25.9348 115.206 25.3675C114.899 24.8471 114.454 24.4219 113.92 24.139C113.339 23.8419 112.693 23.6932 112.041 23.7061C111.383 23.694 110.734 23.8584 110.161 24.1821C109.615 24.4928 109.173 24.9571 108.889 25.5171ZM114.104 26.6867H110.134C110.151 26.4478 110.217 26.2148 110.326 26.0015C110.435 25.7882 110.585 25.5989 110.768 25.4446C111.138 25.1276 111.612 24.9581 112.099 24.9686C112.593 24.9502 113.076 25.1113 113.46 25.4219C113.83 25.7445 114.061 26.1977 114.104 26.6867Z",
    fill: "url(#paint4_linear_9396_16172)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.814 25.1704V29.1868C117.814 29.8804 117.973 30.3858 118.29 30.7031C118.607 31.0363 119.129 31.195 119.836 31.195H121.34V29.8214H120.154C120.049 29.833 119.942 29.8237 119.841 29.7942C119.739 29.7646 119.645 29.7153 119.562 29.6492C119.428 29.4713 119.366 29.2497 119.387 29.0281V25.1749H121.165V23.815H119.387V21.7388H117.814V23.8059H116.526V25.1659L117.814 25.1704Z",
    fill: "url(#paint5_linear_9396_16172)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.375 24.1754C127.821 23.8671 127.195 23.7107 126.561 23.7221C126.093 23.7091 125.629 23.81 125.208 24.0161C124.787 24.2222 124.423 24.5273 124.147 24.9052L123.961 23.8082H122.6V34.094H124.162V30.1546C124.407 30.5094 124.741 30.7932 125.131 30.9774C125.581 31.1922 126.076 31.2964 126.575 31.2811C127.21 31.2991 127.837 31.1422 128.389 30.8278C128.919 30.5094 129.349 30.0494 129.632 29.4996C129.927 28.8738 130.08 28.1903 130.08 27.4982C130.08 26.8061 129.927 26.1226 129.632 25.4968C129.35 24.9435 128.914 24.4843 128.375 24.1754ZM127.87 29.2729C127.678 29.4977 127.438 29.6767 127.168 29.7967C126.898 29.9167 126.605 29.9748 126.31 29.9665C126.014 29.9778 125.72 29.9211 125.449 29.8009C125.179 29.6806 124.939 29.5 124.75 29.2729C124.33 28.7651 124.118 28.1174 124.156 27.4597C124.122 26.8219 124.335 26.1955 124.75 25.7098C124.942 25.4873 125.183 25.3107 125.453 25.193C125.723 25.0754 126.015 25.0196 126.31 25.0299C126.604 25.0226 126.896 25.0798 127.165 25.1972C127.434 25.3147 127.675 25.4896 127.87 25.7098C128.264 26.2186 128.477 26.8436 128.477 27.4869C128.477 28.1301 128.264 28.7552 127.87 29.2639V29.2729Z",
    fill: "url(#paint6_linear_9396_16172)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.752 21.0837V31.195H133.312V21.0837H131.752Z",
    fill: "url(#paint7_linear_9396_16172)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.357 29.8373H142.053C141.722 29.8373 141.563 29.6627 141.563 29.316V26.3989C141.563 25.533 141.289 24.8666 140.754 24.4043C140.219 23.9419 139.438 23.7129 138.454 23.7129C137.652 23.6789 136.86 23.896 136.187 24.334C135.904 24.5273 135.668 24.7824 135.497 25.0799C135.327 25.3775 135.226 25.7099 135.203 26.0521H136.736C136.765 25.8937 136.826 25.7429 136.915 25.6089C137.004 25.4748 137.12 25.3604 137.255 25.2724C137.592 25.0559 137.988 24.9497 138.389 24.9686C138.818 24.9483 139.241 25.0755 139.588 25.329C139.731 25.4452 139.845 25.5932 139.921 25.7613C139.996 25.9294 140.031 26.1128 140.023 26.2969V26.7502H138.157C137.119 26.7502 136.343 26.9768 135.801 27.3712C135.533 27.5736 135.32 27.839 135.179 28.1438C135.038 28.4487 134.975 28.7836 134.994 29.1188C134.979 29.4245 135.04 29.7293 135.171 30.0061C135.302 30.2828 135.499 30.523 135.745 30.7054C136.237 31.0952 136.901 31.2834 137.74 31.2834C138.223 31.3049 138.703 31.1984 139.132 30.9747C139.56 30.751 139.922 30.418 140.18 30.0095C140.167 30.1706 140.188 30.3326 140.243 30.4847C140.298 30.6368 140.385 30.7754 140.497 30.8912C140.699 31.093 141.046 31.195 141.538 31.195H142.361L142.357 29.8373ZM140.017 27.9016V28.1623C140.021 28.4192 139.973 28.6743 139.876 28.9122C139.779 29.1502 139.635 29.3661 139.452 29.5471C139.04 29.9126 138.499 30.1001 137.949 30.0685C137.588 30.0948 137.229 29.992 136.937 29.7783C136.82 29.6898 136.726 29.574 136.663 29.4409C136.6 29.3079 136.571 29.1615 136.577 29.0145C136.568 28.8553 136.598 28.6964 136.667 28.5522C136.735 28.4081 136.838 28.2833 136.967 28.1895C137.298 27.9779 137.688 27.8771 138.08 27.9016H140.017Z",
    fill: "url(#paint8_linear_9396_16172)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.35 30.558C149.96 30.0465 150.356 29.3252 150.461 28.5362H148.874C148.797 28.9534 148.571 29.3281 148.236 29.5892C147.902 29.8503 147.483 29.9797 147.06 29.9528C146.771 29.9661 146.484 29.9115 146.22 29.7934C145.957 29.6753 145.725 29.497 145.543 29.2728C145.151 28.7604 144.952 28.1265 144.98 27.4822C144.954 26.8465 145.153 26.2219 145.543 25.7188C145.727 25.4973 145.959 25.3209 146.222 25.203C146.485 25.0851 146.772 25.029 147.06 25.0388C147.482 25.0277 147.895 25.1604 148.232 25.4151C148.547 25.6751 148.769 26.0296 148.867 26.426H150.47C150.352 25.6577 149.959 24.9584 149.363 24.4586C148.72 23.9494 147.916 23.688 147.096 23.7219C146.411 23.7062 145.734 23.8703 145.132 24.1979C144.58 24.5006 144.128 24.9573 143.831 25.5125C143.513 26.1224 143.356 26.8037 143.377 27.4913C143.363 28.1825 143.518 28.8668 143.831 29.4836C144.123 30.0494 144.574 30.5169 145.13 30.8277C145.724 31.1475 146.392 31.304 147.067 31.281C147.889 31.3135 148.696 31.0577 149.35 30.558Z",
    fill: "url(#paint9_linear_9396_16172)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M152.197 25.5172C151.885 26.1348 151.729 26.8198 151.744 27.5118C151.721 28.1995 151.878 28.8813 152.197 29.4905C152.502 30.0536 152.965 30.5153 153.528 30.8188C154.153 31.1403 154.849 31.2963 155.551 31.2721C156.351 31.3043 157.136 31.0476 157.762 30.549C158.342 30.0884 158.733 29.4312 158.861 28.7018H157.299C157.203 29.0909 156.973 29.4336 156.648 29.6696C156.288 29.9035 155.864 30.0192 155.435 30.0005C155.166 30.013 154.898 29.9694 154.646 29.8727C154.395 29.7759 154.166 29.628 153.975 29.4384C153.584 29.0242 153.367 28.4757 153.37 27.9062V27.8201H158.948C158.977 27.6242 158.991 27.4265 158.991 27.2285C158.994 26.575 158.824 25.9323 158.499 25.3653C158.192 24.845 157.747 24.4197 157.213 24.1369C156.633 23.8395 155.988 23.6907 155.336 23.7039C154.678 23.6913 154.028 23.8557 153.456 24.1799C152.915 24.4943 152.478 24.9589 152.197 25.5172ZM157.413 26.6868H153.435C153.454 26.4479 153.52 26.2152 153.63 26.002C153.739 25.7888 153.89 25.5994 154.073 25.4447C154.442 25.1278 154.915 24.9583 155.401 24.9687C155.895 24.9503 156.378 25.1114 156.762 25.422C157.133 25.7443 157.366 26.1972 157.413 26.6868Z",
    fill: "url(#paint10_linear_9396_16172)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6192 27.1786L55.6328 42.2491C55.6328 44.663 57.5964 46.8435 60.0068 46.9886C60.6428 47.0282 61.2802 46.9372 61.8797 46.7211C62.4791 46.5051 63.028 46.1686 63.4924 45.7324C63.9568 45.2962 64.3269 44.7695 64.5799 44.1849C64.8329 43.6002 64.9634 42.97 64.9635 42.333V15.9884C64.9724 14.7862 64.521 13.6261 63.7019 12.7458C62.8828 11.8655 61.7579 11.3316 60.5577 11.2535C59.0068 11.1674 57.7824 11.8383 56.703 12.9353L40.3636 29.2684C39.3451 30.2967 38.7745 31.6858 38.7764 33.1329L38.79 44.0125L55.6192 27.1786Z",
    fill: "url(#paint11_linear_9396_16172)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7585 15.909C27.7853 14.69 28.2887 13.5299 29.1607 12.6773C30.0327 11.8246 31.204 11.3472 32.4238 11.3472C33.6436 11.3472 34.8149 11.8246 35.6869 12.6773C36.5589 13.5299 37.0622 14.69 37.0891 15.909V42.3374C37.1028 42.9585 36.9923 43.5761 36.764 44.1538C36.5357 44.7316 36.1942 45.258 35.7597 45.7021C35.3251 46.1462 34.8061 46.499 34.2333 46.7399C33.6605 46.9808 33.0453 47.1049 32.4238 47.1049C31.8023 47.1049 31.1871 46.9808 30.6143 46.7399C30.0414 46.499 29.5225 46.1462 29.0879 45.7021C28.6534 45.258 28.3119 44.7316 28.0836 44.1538C27.8553 43.5761 27.7448 42.9585 27.7585 42.3374V15.909Z",
    fill: "url(#paint12_linear_9396_16172)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.423 9.32928C33.3461 9.32973 34.2486 9.05648 35.0164 8.5441C35.7841 8.03171 36.3826 7.30322 36.7361 6.45077C37.0896 5.59833 37.1822 4.66024 37.0022 3.75517C36.8222 2.85011 36.3777 2.01874 35.7249 1.36624C35.0722 0.713746 34.2405 0.269435 33.3351 0.0895214C32.4297 -0.0903926 31.4912 0.00217396 30.6384 0.355511C29.7857 0.708847 29.0569 1.30708 28.5443 2.07452C28.0317 2.84196 27.7583 3.74414 27.7588 4.66691C27.7588 5.90345 28.2502 7.08934 29.1249 7.96371C29.9996 8.83807 31.186 9.32928 32.423 9.32928Z",
    fill: "url(#paint13_linear_9396_16172)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34665 31.0659V15.9953C9.34665 13.5792 7.38075 11.401 4.97042 11.2559C4.33342 11.214 3.6946 11.3033 3.09351 11.5182C2.49242 11.7331 1.94186 12.0691 1.47593 12.5053C1.01 12.9415 0.638602 13.4687 0.384747 14.0542C0.130892 14.6397 -2.0933e-05 15.2711 0.000113998 15.9092V42.2606C-0.00824414 43.4626 0.443279 44.6224 1.26228 45.5026C2.08129 46.3828 3.20585 46.9169 4.40582 46.9955C5.95678 47.0816 7.18121 46.4107 8.26053 45.3137L24.6 28.9784C25.6174 27.9539 26.188 26.5687 26.1872 25.1252L26.1759 14.2319L9.34665 31.0659Z",
    fill: "url(#paint14_linear_9396_16172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9396_16172",
    x1: 74.3008,
    y1: 26.1382,
    x2: 84.9806,
    y2: 26.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9396_16172",
    x1: 3121.99,
    y1: 981.427,
    x2: 3361.6,
    y2: 981.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9396_16172",
    x1: 1936.54,
    y1: 959.122,
    x2: 2010.37,
    y2: 959.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9396_16172",
    x1: 3380.12,
    y1: 1238.58,
    x2: 3591.26,
    y2: 1238.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9396_16172",
    x1: 3791.96,
    y1: 980.46,
    x2: 4024.43,
    y2: 980.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9396_16172",
    x1: 2728.91,
    y1: 1173.98,
    x2: 2831.11,
    y2: 1173.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9396_16172",
    x1: 4382.75,
    y1: 1399.08,
    x2: 4628.78,
    y2: 1399.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9396_16172",
    x1: 1083.11,
    y1: 1238.58,
    x2: 1093.85,
    y2: 1238.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9396_16172",
    x1: 4734.94,
    y1: 981.393,
    x2: 4974.48,
    y2: 981.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9396_16172",
    x1: 4833.21,
    y1: 979.905,
    x2: 5055.2,
    y2: 979.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9396_16172",
    x1: 5211.66,
    y1: 980.759,
    x2: 5443.56,
    y2: 980.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9396_16172",
    x1: 6.48298,
    y1: 58.7454,
    x2: 71.4094,
    y2: 23.0025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9396_16172",
    x1: 1630.88,
    y1: 9486.02,
    x2: 1630.88,
    y2: 16900.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9396_16172",
    x1: 1630.88,
    y1: 2432.25,
    x2: 1630.88,
    y2: 4365.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9396_16172",
    x1: 7.33247,
    y1: -15104.7,
    x2: 8412.71,
    y2: -11717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBf);
export default __webpack_public_path__ + "static/media/logo-bf.22c05032acba6d357aae352eab6917a2.svg";
export { ForwardRef as ReactComponent };